<ng-container formGroupName="customerData">
  <fieldset class="row">
    <div class="row mb-3">
      <div class="col-12">
        <div class="gender-button"
             (click)="selectGender(Gender.Female)"
             [ngClass]="{'selected': customerDataControl.gender.value === Gender.Female}"
             role="checkbox"
             [attr.aria-checked]="customerDataControl.gender.value === Gender.Female">
          <svg version="1.1"
               xmlns="http://www.w3.org/2000/svg"
               xmlns:xlink="http://www.w3.org/1999/xlink"
               class="gender-icon"
               x="0px"
               y="0px"
               viewBox="0 0 362.8 579.3"
               xml:space="preserve">
            <g>
              <circle cx="185.4"
                      cy="61.6"
                      r="61.6" />
              <path d="M361.4,316.6l-80-126.2c-14.8-20.2-38.4-32.1-63.4-32.1h-73.2c-25,0-48.6,11.9-63.4,32.1l-80,126.2
c-2.5,3.9-1.5,9.1,2.3,11.8c3.5,2.5,8.2,2.2,11.3-0.8L86,258.6c3.1-3,7.8-3.7,11.6-1.6v0c3.7,2,5.7,6.2,5,10.4L72.2,436.5
c-1.5,8.2,4.8,15.8,13.2,15.8h50.3c6,0,10.9,4.7,11.1,10.7l1.5,37.2c0.2,5.6,1.2,11.1,2.8,16.4l16.3,53.2c1.5,4.8,5.3,8.4,10,9.6h8
c4.7-1.2,8.5-4.8,10-9.6l16.3-53.2c1.6-5.3,2.6-10.9,2.8-16.4l1.5-37.2c0.2-6,5.2-10.7,11.1-10.7h50.3c8.3,0,14.7-7.5,13.2-15.8
l-30.4-169.1c-0.8-4.2,1.3-8.4,5-10.4v0c3.8-2.1,8.5-1.4,11.6,1.6l71.1,69.1c3.1,3,7.8,3.3,11.3,0.8h0
C362.9,325.7,363.9,320.5,361.4,316.6z" />
            </g>
          </svg>
          <div class="form-check custom-control custom-radio custom-control-inline">
            <input class="form-check-input custom-control-input"
                   type="radio"
                   name="gender"
                   id="genderInput1"
                   [value]="Gender.Female"
                   [ngClass]="{ 'is-invalid': customerDataControl.gender.invalid && isFormSubmitted, 'is-valid': customerDataControl.gender.valid && customerDataControl.gender.value === Gender.Female }"
                   formControlName="gender">
            <label class="form-check-label custom-control-label"
                   for="genderInput1">
              {{ 'SHARED.FORM-INPUTS.CUSTOMER-GENDER-INPUT.WOMAN' | translate }}
            </label>
          </div>
        </div>

        <div class="gender-button"
             (click)="selectGender(Gender.Male)"
             [ngClass]="{'selected': customerDataControl.gender.value === Gender.Male}"
             role="checkbox"
             [attr.aria-checked]="customerDataControl.gender.value === Gender.Male">
          <svg version="1.1"
               xmlns="http://www.w3.org/2000/svg"
               xmlns:xlink="http://www.w3.org/1999/xlink"
               class="gender-icon"
               x="0px"
               y="0px"
               viewBox="0 0 365.5 579.8"
               xml:space="preserve">
            <g>
              <path d="M364,315.8l-45.4-74.6L281,183.4c-9.6-14.7-25.6-24-43.1-25.1H127.6c-17.5,1.1-33.5,10.4-43.1,25.1l-37.6,57.8L1.5,315.8
c-2.6,4.3-1.7,10,2.2,13.2l2.6,2.2c3.7,3,9,3.1,12.7,0.2l46-37.9c2.7-2.1,4.9-4.7,6.7-7.6l20.1-29.2c2.1-3.6,6.3-5.3,10.3-4.2
c4,1.1,6.8,4.7,6.8,8.9l-0.7,214.4c0,4.5,0.5,9.1,1.5,13.5l21.8,80.4c1.6,6,7.1,10.2,13.4,10.2h4.7c7.6,0,13.8-6.2,13.8-13.8
l0-139.3c0-8.8,6.7-16.1,15.4-17h8.1c8.7,0.9,15.4,8.2,15.4,17l0,139.3c0,7.6,6.2,13.8,13.8,13.8h4.7c6.2,0,11.7-4.2,13.4-10.2
l21.8-80.4c1-4.4,1.5-9,1.5-13.5l-0.7-214.4c0-4.2,2.8-7.8,6.8-8.9c4-1.1,8.2,0.7,10.3,4.2l20.1,29.2c1.7,2.9,4,5.5,6.7,7.6
l46,37.9c3.8,2.9,9,2.8,12.7-0.2l2.6-2.2C365.7,325.8,366.6,320.1,364,315.8z" />
              <circle cx="183.7"
                      cy="61.6"
                      r="61.6" />
            </g>
          </svg>

          <div class="form-check custom-control custom-radio custom-control-inline">
            <input class="form-check-input custom-control-input"
                   type="radio"
                   name="gender"
                   id="genderInput2"
                   [value]="Gender.Male"
                   formControlName="gender"
                   [ngClass]="{ 'is-invalid': customerDataControl.gender.invalid && isFormSubmitted, 'is-valid': customerDataControl.gender.valid && customerDataControl.gender.value === Gender.Male}">
            <label class="form-check-label custom-control-label"
                   for="genderInput2">
              {{ 'SHARED.FORM-INPUTS.CUSTOMER-GENDER-INPUT.MAN' | translate }}
            </label>
          </div>
        </div>

      </div>
      <div *ngIf="customerDataControl.gender.invalid && (customerDataControl.gender.dirty || customerDataControl.gender.touched)  || isFormSubmitted"
           class="col-12 text-danger"
           [@inOutAnimation]>
        <div *ngIf="customerDataControl.gender.errors?.required">
          {{ 'SHARED.FORM-INPUTS.CUSTOMER-GENDER-INPUT.ERROR-REQUIRED' | translate }}
        </div>
      </div>
    </div>

  </fieldset>
  <div class="row mb-3">
    <div class="col-12">
      <label for="nameInput"
             class="visually-hidden">{{ 'SHARED.FORM-INPUTS.CUSTOMER-NAME-INPUT.LABEL' | translate }}</label>
      <input id="nameInput"
             autocomplete="given-name"
             name="firstName"
             class="form-control"
             type="text"
             placeholder="{{ 'SHARED.FORM-INPUTS.CUSTOMER-NAME-INPUT.PLACEHOLDER' | translate }}"
             trim
             required
             formControlName="firstName"
             [ngClass]="{ 'is-invalid': customerDataControl.firstName.invalid && (customerDataControl.firstName.dirty || customerDataControl.firstName.touched), 'is-valid': customerDataControl.firstName.valid }">
      <div *ngIf="customerDataControl.firstName.invalid && (customerDataControl.firstName.dirty || customerDataControl.firstName.touched)  || isFormSubmitted"
           class="text-danger"
           [@inOutAnimation]>
        <div *ngIf="customerDataControl.firstName.errors?.required">
          {{ 'SHARED.FORM-INPUTS.CUSTOMER-NAME-INPUT.ERROR-REQUIRED' | translate }}
        </div>
        <div *ngIf="customerDataControl.firstName.errors?.pattern">
          {{ 'SHARED.FORM-INPUTS.ANY-INPUT.ERROR-ONLY-LETTERS' | translate }}
        </div>
      </div>
    </div>
  </div>

  <div class="row mb-3">
    <div class="col-12 col-sm-3 mb-3 mb-sm-0">
      <label for="nameInfixInput"
             class="visually-hidden">{{ 'SHARED.FORM-INPUTS.CUSTOMER-NAME-INFIX.LABEL' | translate }}</label>
      <input class="form-control"
             autocomplete="name-infix"
             name="nameInfix"
             id="nameInfixInput"
             type="text"
             placeholder="{{ 'SHARED.FORM-INPUTS.CUSTOMER-NAME-INFIX.PLACEHOLDER' | translate }}"
             trim
             formControlName="nameInfix">
      <div *ngIf="customerDataControl.nameInfix.invalid && (customerDataControl.nameInfix.dirty || customerDataControl.nameInfix.touched)"
           class="text-danger"
           [@inOutAnimation]>
        <div *ngIf="customerDataControl.nameInfix.errors?.pattern">
          <small>
            {{ 'SHARED.FORM-INPUTS.CUSTOMER-NAME-INFIX.ERROR-PATTERN' | translate }}
          </small>
        </div>
      </div>
    </div>
    <div class="col-12 col-sm-9">
      <label for="lastNameInput"
             class="visually-hidden">{{ 'SHARED.FORM-INPUTS.CUSTOMER-LAST-NAME.LABEL' | translate }}</label>
      <input class="form-control"
             autocomplete="family-name"
             name="lastName"
             type="text"
             id="lastNameInput"
             placeholder="{{ 'SHARED.FORM-INPUTS.CUSTOMER-LAST-NAME.PLACEHOLDER' | translate }}"
             required
             trim
             formControlName="lastName"
             [ngClass]="{ 'is-invalid': customerDataControl.lastName.invalid && (customerDataControl.lastName.dirty || customerDataControl.lastName.touched) , 'is-valid': customerDataControl.lastName.valid}">
      <div *ngIf="customerDataControl.lastName.invalid && (customerDataControl.lastName.dirty || customerDataControl.lastName.touched)  || isFormSubmitted"
           class="text-danger"
           [@inOutAnimation]>
        <div *ngIf="customerDataControl.lastName.errors?.required">
          {{ 'SHARED.FORM-INPUTS.CUSTOMER-LAST-NAME.ERROR-REQUIRED' | translate }}
        </div>
        <div *ngIf="customerDataControl.lastName.errors?.pattern">
          {{ 'SHARED.FORM-INPUTS.ANY-INPUT.ERROR-ONLY-LETTERS' | translate }}
        </div>
      </div>
    </div>
  </div>

  <div class="row mb-3">
    <div class="col-12">
      <label for="emailInput"
             class="visually-hidden">{{ 'SHARED.FORM-INPUTS.CUSTOMER-EMAIL.LABEL' | translate }}</label>
      <input class="form-control"
             autocomplete="email"
             name="email"
             id="emailInput"
             type="text"
             placeholder="{{ 'SHARED.FORM-INPUTS.CUSTOMER-EMAIL.PLACEHOLDER' | translate }}"
             trim
             required
             formControlName="email"
             [ngClass]="{ 'is-invalid': customerDataControl.email.invalid && (customerDataControl.email.dirty || customerDataControl.email.touched) , 'is-valid': customerDataControl.email.valid}">
      <div *ngIf="customerDataControl.email.invalid && (customerDataControl.email.dirty || customerDataControl.email.touched) || isFormSubmitted"
           class="text-danger"
           [@inOutAnimation]>
        <div *ngIf="customerDataControl.email.errors?.required">
          {{ 'SHARED.FORM-INPUTS.CUSTOMER-EMAIL.ERROR-REQUIRED' | translate }}
        </div>
        <div *ngIf="customerDataControl.email.errors?.pattern">
          {{ 'SHARED.FORM-INPUTS.CUSTOMER-EMAIL.ERROR-PATTERN' | translate }}
        </div>
      </div>
    </div>
  </div>

  <div class="row mb-3">
    <div class="col-3"
         *ngIf="countries">
      <label for="country"
             class="visually-hidden">{{ 'SHARED.FORM-INPUTS.CUSTOMER-COUNTRY-SELECT.LABEL' | translate }}</label>
      <select id="country"
              name="country"
              formControlName="country"
              class="form-select"
              autocomplete="off"
              [compareWith]="compareCountryCodes">
        <option *ngFor="let country of countries"
                [ngValue]="country">
          {{ country?.twoLetterIsoCode }}
        </option>
      </select>
    </div>
    <div class="col-9">
      <div class="input-group">
        <div class="input-group-prepend">
          <span class="input-group-text">{{ customerDataControl.country.value?.phoneCode }}</span>
        </div>
        <label for="phoneInput"
               class="visually-hidden">{{ 'SHARED.FORM-INPUTS.CUSTOMER-PHONE-NUMBER-INPUT.LABEL' | translate }}</label>
        <input class="form-control"
               autocomplete="tel-national"
               type="tel"
               name="mobileNumber"
               id="phoneInput"
               placeholder="{{ 'SHARED.FORM-INPUTS.CUSTOMER-PHONE-NUMBER-INPUT.PLACEHOLDER' | translate }}"
               trim
               required
               formControlName="mobileNumber"
               [ngClass]="{
        'is-invalid': customerDataControl.mobileNumber.invalid && (customerDataControl.mobileNumber.dirty || customerDataControl.mobileNumber.touched),
        'is-valid': customerDataControl.mobileNumber.valid}">
      </div>
    </div>

    <div *ngIf="customerDataControl.mobileNumber.invalid && (customerDataControl.mobileNumber.dirty || customerDataControl.mobileNumber.touched)  || isFormSubmitted"
         class="col-9 offset-3 text-danger"
         [@inOutAnimation]>
      <div *ngIf="customerDataControl.mobileNumber.errors?.required">
        {{ 'SHARED.FORM-INPUTS.CUSTOMER-PHONE-NUMBER-INPUT.ERROR-REQUIRED' | translate }}
      </div>
      <div *ngIf="customerDataControl.mobileNumber.errors?.phoneInputFeedback">
        {{ customerDataControl.mobileNumber.errors.phoneInputFeedback | translate }}
      </div>
    </div>
  </div>
</ng-container>

<ng-container>
  <div class="row mb-3">
    <div class="col-12">
      <label for="passwordInput"
             class="visually-hidden">{{ 'SHARED.FORM-INPUTS.CUSTOMER-PASSWORD-INPUT.LABEL' | translate }}</label>
      <input class="form-control"
             autocomplete="new-password"
             name="passwordInput"
             id="passwordInput"
             type="password"
             placeholder="{{ 'SHARED.FORM-INPUTS.CUSTOMER-PASSWORD-INPUT.PLACEHOLDER' | translate }}"
             formControlName="password"
             required
             [ngClass]="{
      'is-invalid': registrationForm.controls.password.invalid && (registrationForm.controls.password.dirty || registrationForm.controls.password.touched),
      'is-valid': registrationForm.controls.passwordRepeat.valid}">
      <div *ngIf="registrationForm.controls.password.invalid && (registrationForm.controls.password.dirty || registrationForm.controls.password.touched)  || isFormSubmitted"
           class="text-danger"
           [@inOutAnimation]>
        <div *ngIf="registrationForm.controls.password.errors?.required">
          {{ 'SHARED.FORM-INPUTS.CUSTOMER-PASSWORD-INPUT.ERROR-REQUIRED' | translate }}
        </div>
        <div *ngIf="registrationForm.controls.password.errors?.minlength && customerDataControl.mobileNumber.errors?.maxlength">
          {{ 'SHARED.FORM-INPUTS.CUSTOMER-PASSWORD-INPUT.ERROR-LENGTH' | translate }}
        </div>
        <div *ngIf="registrationForm.controls.password.errors?.pattern">
          {{ 'SHARED.FORM-INPUTS.CUSTOMER-PASSWORD-INPUT.ERROR-PATTERN' | translate }}
        </div>
      </div>
    </div>
  </div>
  <div class="row mb-3">
    <div class="col-12">
      <label for="repeatPasswordInput"
             class="visually-hidden">{{ 'SHARED.FORM-INPUTS.CUSTOMER-PASSWORD-INPUT.REPEAT-INPUT.LABEL' | translate }}
      </label>
      <input class="form-control"
             autocomplete="off"
             name="repeatPasswordInput"
             id="repeatPasswordInput"
             type="password"
             required
             placeholder="{{ 'SHARED.FORM-INPUTS.CUSTOMER-PASSWORD-INPUT.REPEAT-INPUT.PLACEHOLDER' | translate }}"
             formControlName="passwordRepeat"
             [ngClass]="{
          'is-invalid': registrationForm.controls.passwordRepeat.invalid && (registrationForm.controls.passwordRepeat.dirty || registrationForm.controls.passwordRepeat.touched),
          'is-valid': registrationForm.controls.passwordRepeat.valid}">
      <div *ngIf="registrationForm.controls.passwordRepeat.invalid && (registrationForm.controls.passwordRepeat.dirty || registrationForm.controls.passwordRepeat.touched)  || isFormSubmitted"
           class="text-danger"
           [@inOutAnimation]>
        <div *ngIf="registrationForm.controls.passwordRepeat.errors?.required">
          {{ 'SHARED.FORM-INPUTS.CUSTOMER-PASSWORD-INPUT.REPEAT-INPUT.ERROR-REQUIRED' | translate }}
        </div>
        <div *ngIf="registrationForm.controls.passwordRepeat.errors?.repeatPasswordInputFeedback">
          {{registrationForm.controls.passwordRepeat.errors.repeatPasswordInputFeedback | translate }}
        </div>
      </div>
    </div>
  </div>
</ng-container>
